'use strict';

var _has2 = _interopRequireDefault(require("lodash/has"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

module.exports =
/*#__PURE__*/
function () {
  function Op(darc) {
    _classCallCheck(this, Op);

    this.darc = darc;
  }

  _createClass(Op, [{
    key: "use",
    value: function use(cursor) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.child.apply(this, [cursor].concat(args));
    }
  }, {
    key: "child",
    value: function child(cursor) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      var schema = this.schema.apply(this, [cursor].concat(args));
      var child; // TODO: We should always use non-array schema where possible internally
      // and just use the value of the elements (whether it is an array, a 2d
      // array etc.) to determine how to operate on it

      var recordSchema = this.darc.unboxCollectionSchema(schema);

      if ((0, _has2.default)(recordSchema, '$.Point')) {
        child = new recordSchema.$.Point(cursor, this);
      } else {
        child = new this.darc.BasePoint(cursor, this);
      }

      child.$.args = args;
      child.$.schema = schema;
      return child;
    }
  }, {
    key: "schema",
    value: function schema(cursor) {
      return cursor.$.schema;
    }
  }]);

  return Op;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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